import { FeatureCode } from "@wallet-manager/node-types";

import { Box } from "../../../components/MuiGenerals";
import { usePermission, useTabs, useTranslation } from "../../../hooks";
import { useAppDispatch } from "../../../reducer/hooks";

import ContractSweepRecipientGroupTab from "./components/ContractSweepRecipientGroupTab";
import ContractSweepRecipientTab from "./components/ContractSweepRecipientTab";

export const PERMISSION_KEY =
  FeatureCode.FeaturesReport.ContractSweepRecipientBalanceReport;

const CONTRACT_SWEEP_RECIPIENT_GROUP_TAB_PERMISSION =
  PERMISSION_KEY.TabContractSweepRecipientGroup.prefix;
const CONTRACT_SWEEP_RECIPIENT_TAB_PERMISSION =
  PERMISSION_KEY.TabContractSweepRecipient.prefix;

export const TRANSLATE_PREFIX = "contractSweepRecipientBalanceReport";

function ContractSweepRecipientBalanceReport() {
  const { t } = useTranslation(TRANSLATE_PREFIX);

  const { hasPermission } = usePermission();
  const dispatch = useAppDispatch();

  const tabConfigArr = [
    {
      name: t("contractSweepRecipientGroup"),
      value: CONTRACT_SWEEP_RECIPIENT_GROUP_TAB_PERMISSION,
    },
    {
      name: t("contractSweepRecipient"),
      value: CONTRACT_SWEEP_RECIPIENT_TAB_PERMISSION,
    },
  ].filter(({ value }) => hasPermission(value));

  const { Tabs, tabValue } = useTabs(tabConfigArr);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        ">div": {
          ">div": {
            paddingTop: "2rem",
            ":first-of-type": {
              margin: "0 1.5rem",
            },
          },
        },
      }}
    >
      <Tabs>
        {tabValue === CONTRACT_SWEEP_RECIPIENT_GROUP_TAB_PERMISSION && (
          <ContractSweepRecipientGroupTab />
        )}
        {tabValue === CONTRACT_SWEEP_RECIPIENT_TAB_PERMISSION && (
          <ContractSweepRecipientTab />
        )}
      </Tabs>
    </Box>
  );
}

export default ContractSweepRecipientBalanceReport;
